import { render, staticRenderFns } from "./_base-checkbox.vue?vue&type=template&id=360a8ef0&scoped=true&"
import script from "./_base-checkbox.vue?vue&type=script&lang=js&"
export * from "./_base-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./_base-checkbox.vue?vue&type=style&index=0&id=360a8ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a8ef0",
  null
  
)

export default component.exports